export enum SubscriptionRequestState {
  Pending = 1,
  DeductingFunds = 2,
  InProcess = 3,
  Completed = 4,
  Failed = 5,
  InProcessCancel = 6,
  Cancelled = 7,
  Active = 8,
}
